import { useCallback, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { usePreviousStepPathname } from 'components/modules/Insurance/hooks/usePreviousStepPathname';
import { Insurance } from 'constants/routes';
import { useRouteMatch } from 'hooks/useRouteMatch';
import { getPolicyholder } from 'store/insurance/actions';
import { selectPageLoading } from 'store/insurance/selectors';
import { insAnketaChangeByKey } from 'store/insuranceAnketa';
import { FIELDS } from 'store/insuranceAnketa/constants';
import { selectField } from 'store/insuranceAnketa/selectors';

import { useDisabledFields } from './hooks/useDisabledFields';
import { useSubmit } from './hooks/useSubmit';

const { ROUTES, ROUTE_NAMES } = Insurance;

export const usePolicyHolderPresenter = () => {
  const dispatch = useDispatch();

  const loading = useSelector(selectPageLoading(ROUTE_NAMES.POLICYHOLDER));
  const ownerIsInsurer = useSelector(selectField(FIELDS.OWNER_IS_INSURER));

  const { pathname: previousPagePath } = usePreviousStepPathname();
  const { params } = useRouteMatch({ routes: ROUTES }) ?? {};
  const { id: worksheetId } = params ?? {};

  const { disabled: pageRestrict } = useDisabledFields();
  const { onSubmit } = useSubmit();

  const onChangeOwnerIsInsurer = useCallback((ownerIsInsurer) => {
    dispatch(insAnketaChangeByKey({ key: FIELDS.OWNER_IS_INSURER, value: ownerIsInsurer }));
  }, []);

  useEffect(() => {
    dispatch(getPolicyholder(worksheetId));
  }, [worksheetId]);

  return {
    disabled: pageRestrict,
    loading,
    onChangeOwnerIsInsurer,
    onSubmit,
    ownerIsInsurer,
    previousPagePath,
  };
};
